import React from 'react';

/**
 * NumberField component - handles number input type
 */
function NumberField({ field, index, value, onChange, formId }) {
    const fieldId = `${formId}_${field.name}_${index}`;

    return (
        <input
            type="number"
            id={fieldId}
            value={value || ''}
            onChange={(e) => onChange(index, e.target.value)}
            className="w-full px-3 py-2 bg-surface-2 text-content border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-amber placeholder:text-content-muted"
            placeholder={field.placeholder || ''}
        />
    );
}

export default NumberField;
